// How far ahead of the car the camera should sit, as a function of the drive state. Pure —
// no Phaser — so `node --test` covers it; OutsideScene and TrainingRouteScene add the
// result to the car's x before centring, and their existing eased follow smooths the slide.
//
// At rest the car is centred. As it speeds up the camera moves out in the direction of
// travel, so that flat out the car sits close to the trailing edge of the screen
// and the child sees what they are driving INTO — a STOP sign, a child at a zebra, a parked
// car — a good second earlier than a centred camera would show it. Reversing looks the
// other way, at the same rate.

export const LOOKAHEAD_MAX_PX = 470;       // ~37% of GAME_WIDTH ahead when flat out: the car's tail
                                           // ends up ~30 px inside the trailing screen edge
export const LOOKAHEAD_FULL_AT_KMH = 50;   // town speed = fully ahead; faster changes nothing

/**
 * Signed x offset (world px) to add to the car's x: negative facing left, positive facing
 * right, 0 at a standstill. `drive` is CarController's drive state (`facing` ±1, `v` km/h,
 * `reversing`).
 */
export function lookahead(drive) {
  if (!drive) return 0;
  const dir = drive.reversing ? -drive.facing : drive.facing;
  const t = Math.min(1, Math.max(0, Math.abs(drive.v) / LOOKAHEAD_FULL_AT_KMH));
  if (t === 0) return 0;
  // Ease-out: most of the slide happens while pulling away, then it settles.
  return dir * LOOKAHEAD_MAX_PX * t * (2 - t);
}
